import React from 'react';
import { X } from 'lucide-react';
import HoverTooltip from '../../../components/HoverTooltip';
import type { ShownInventory } from './locationCases';

// loading = QS read running (spinner); failed = QS did not answer (red x, never "—"). The TOTAL comes from the backend.
const LocationCasesCell: React.FC<{ inventory?: ShownInventory; t: (key: string) => string; loading?: boolean; failed?: boolean }> = ({ inventory, t, loading, failed }) => {
  if (loading) return <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary-600" />;
  if (failed) return <HoverTooltip label={t('itemSummaryReport.inventoryFailed')} textClassName="text-xs font-normal"><X className="w-4 h-4 text-red-600 dark:text-red-400" /></HoverTooltip>;
  if (!inventory || inventory.rows.length === 0) return <span className="text-gray-400 dark:text-gray-500">—</span>;
  const cs = t('itemSummaryReport.casesUnit');
  return (
    <div className="min-w-[6rem] space-y-0.5">
      {inventory.rows.map(r => (
        <div key={r.location_code} className="flex items-center justify-between gap-2">
          <span className="font-mono text-[10px] px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300">
            {r.location_code}
          </span>
          <span>{r.cases} {cs}</span>
        </div>
      ))}
      {inventory.rows.length > 1 && (
        <div className="flex items-center justify-between gap-2 pt-0.5 border-t border-gray-200 dark:border-gray-600">
          <span className="text-[10px] uppercase text-gray-400 dark:text-gray-500">{t('itemSummaryReport.total')}</span>
          <span className="font-semibold">{inventory.total} {cs}</span>
        </div>
      )}
    </div>
  );
};

export default LocationCasesCell;
